<mat-dialog-content style="height: 63vh;">
    <div style="margin-bottom: 2%;">
        <strong >{{titulo}}</strong>
    </div>
    <div [hidden]="nombreObraSocial!=''" style="width: 40%;">
        <mat-form-field style="width: 80%; font-size: 2.0vh;">
            <input matInput placeholder="Obra social"
                [(ngModel)]=txtObraSocial autocomplete="off"
                (keydown.enter)="buscarObraSocial()">
        </mat-form-field>
        <i class="fas fa-search" style="font-size: 1.5em; cursor: pointer; color: #4b8cc5;
            margin-top: 0px;" (click)="buscarObraSocial()"
            matTooltip="Buscar obra social">
        </i>
    </div>
    <div [hidden]="nombreObraSocial==''" style="text-align: start; margin-right: 5px;
        margin-top: 30px;">
        <i class="fas fa-trash" style=" margin-right: 5px;
            font-size: 1.5em; cursor: pointer; color: #4b8cc5;
            margin-top: 0px;" (click)="eliminarObraSocial()"
            matTooltip="Eliminar la obra social">
        </i>
        <mat-label>{{nombreObraSocial}}</mat-label>
    </div>
    <div [hidden]="noTienePlanes" style="margin-top: 20px;" >
        <div [hidden]="nombrePlanObraSocial!=''" style="width: 40%;">
            <mat-form-field style="width: 80%; font-size: 2.0vh;">
                <input matInput placeholder="Plan obra social"
                    [(ngModel)]=txtPlanObraSocial autocomplete="off"
                    (keydown.enter)="buscarPlanObraSocial()">
            </mat-form-field>
            <i class="fas fa-search" style="font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                margin-top: 0px;" (click)="buscarObraSocial()"
                matTooltip="Buscar plan de la obra social">
            </i>
        </div>
        <div [hidden]="nombrePlanObraSocial==''" style="text-align: start; margin-right: 5px;
            margin-top: 30px;">
            <i class="fas fa-trash" style=" margin-right: 5px;
                font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                margin-top: 0px;" (click)="eliminarPlanObraSocial()"
                matTooltip="Eliminar plan de la obra social">
            </i>
            <mat-label>{{nombrePlanObraSocial}}</mat-label>
        </div>
    </div>
    <div style="width: 90%; margin-top: 10px;">
        <table style="width: 100%;">
            <tr>
                <td style="width: 40%;">
                    <mat-form-field style="width: 80%; font-size: 2.0vh;">
                        <input matInput placeholder="Nº Afiliado"
                            [(ngModel)]=txtNumAfiliado autocomplete="off">
                    </mat-form-field>
                </td>
                <td style="width: 5%;"></td>
                <td style="width: 40%;" [hidden]="noGravado">
                    <mat-form-field appearance="fill" style="width: 100%;">
                        <mat-label>Tipo de afiliado</mat-label>
                        <mat-select [(ngModel)]="tipoGravado">
                        <mat-option value="GRAVADO">Gravado</mat-option>
                        <mat-option value="NOGRAVADO">No gravado</mat-option>
                        </mat-select>
                    </mat-form-field>
                </td>
                <td style="width: 40%;" [hidden]="!noGravado">
                </td>
                <td style="width: 15%;"></td>
            </tr>
        </table>
    </div>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
        <tr>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
                    <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Cancelar
                </button>
            </td>
            <td style="width: 20%;"></td>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="almacenar()" style="margin-left: 30px;">
                    <i class="fas fa-save fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Almacenar
                </button>
            </td>
        </tr>
    </table>
</div>
